export enum Flag {
  FALSE = 0,
  TRUE = 1
}

export enum AnswerType {
  VAS = 1,
  VRS = 2,
  NRS = 3,
  LIKERT = 4,
  INTEGER = 5,
  FLOAT = 6,
  TEXT = 7,
  CHECKBOX = 8,
  IMAGE = 9,
  MULTIPLE_TEXT_FORM = 10,
  SELECT_BOX = 11,
  TEXTAREA = 12,
  IMAGE_SELECTION = 13,
  TIME = 14,
  YEAR = 15,
  YEAR_MONTH = 16,
  DATE = 17,
  VERTICAL_VAS = 18,
  TEL = 19,
}

export enum AnswerFrequencyType {
  WEEKDAY = 0,
  PERIOD = 1,
  ANYTIME = 10,
}
